module.exports = __webpack_public_path__ + "img/mailchimp.1a56dfc6.png";